/**
 * Canadian provinces mapping from long names to integer IDs
 */
export const CANADIAN_PROVINCES = {
	'Alberta': '57',
	'British Columbia': '58',
	'Manitoba': '59',
	'New Brunswick': '60',
	'Newfoundland and Labrador': '61',
	'Northwest Territories': '62',
	'Nova Scotia': '63',
	'Nunavut': '64',
	'Ontario': '65',
	'Prince Edward Island': '66',
	'Quebec': '67',
	'Saskatchewan': '68',
	'Yukon': '69'
};

/**
 * Mexican states mapping from long names to integer IDs
 */
export const MEXICAN_STATES = {
    'Aguascalientes': '70',
    'Baja California': '71',
    'Baja California Sur': '72',
    'Campeche': '73',
    'Chiapas': '74',
    'Chihuahua': '75',
    'Coahuila de Zaragoza': '76',
    'Colima': '77',
    'Durango': '78',
    'Guanajuato': '79',
    'Guerrero': '80',
    'Hidalgo': '81',
    'Jalisco': '82',
    'México': '83',
    'Distrito Federal': '84',
    'Michoacán de Ocampo': '85',
    'Morelos': '86',
    'Nayarit': '87',
    'Nuevo León': '88',
    'Oaxaca': '89',
    'Puebla': '90',
    'Querétaro': '91',
    'Quintana Roo': '92',
    'San Luis Potosí': '93',
    'Sinaloa': '94',
    'Sonora': '95',
    'Tabasco': '96',
    'Tamaulipas': '97',
    'Tlaxcala': '98',
    'Veracruz de Ignacio de la Llave': '99',
    'Yucatán': '100',
    'Zacatecas': '101'
};

/** US states + DC region IDs (51 regions). */
export const US_REGION_IDS = new Set([
	'01', '02', '04', '05', '06', '08', '09', '10', '11', '12', '13', '15', '16', '17', '18', '19',
	'20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35',
	'36', '37', '38', '39', '40', '41', '42', '44', '45', '46', '47', '48', '49', '50', '51', '53',
	'54', '55', '56',
]);

/** Canadian province/territory IDs (13 regions). */
export const CAN_REGION_IDS = new Set([
	'57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69',
]);

/** Mexican state IDs (32 regions). */
export const MX_REGION_IDS = new Set([
	'70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85',
	'86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', '101',
]);
